
import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getCookieJson } from "../utils/cookie";
import { AuthHeader } from "../containers";
import AuthPageWrapper from "../components/layout/AuthPageWrapper/AuthPageWrapper";
import { IAM_COOKIE_NAME } from "../settings/config";
import AnalysisInProgressContextWrapper from "../analysis/ContextWrapper";
import { startParsiveWidget } from "../utils/parsive";


const ProtectedRoute = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const pagesWithoutSidebarAndHeader = ["/free-trial-setup", "/user/account/setup"]

    let isAuthenticated = false;
    const iamCookie = getCookieJson(IAM_COOKIE_NAME);
    if (iamCookie && iamCookie["access_token"]) {
        isAuthenticated = true;
    }

    // Start the Parsive widget only while the user is authenticated; the returned
    // function stops it when the user leaves the protected area (logout/unmount).
    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }
        return startParsiveWidget();
    }, [isAuthenticated]);

    if (!isAuthenticated) {
        return <Navigate to="/auth/login" replace />;
    }

    return (
        <AuthPageWrapper showSideBar={!pagesWithoutSidebarAndHeader.includes(pathname)}>
            <AuthHeader showPageHeader={!pagesWithoutSidebarAndHeader.includes(pathname)} />
            <AnalysisInProgressContextWrapper>
                <Outlet />
            </AnalysisInProgressContextWrapper>
        </AuthPageWrapper>
    );
};

export default ProtectedRoute;
